import { createContext } from "react";

export default createContext({
    loggedin: false,
    username: null,
    email: null,
    balance: null
});